import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'
import { cancelInvoiceFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormSelectField from '../FormSelectField'
import FormTextField from '../FormTextField'

const CancelRejectInvoiceForm = ({ onSubmit, cancelDialog, currentAction }) => {
  const classes = formStyles()
  const formActions = useFormik({
    initialValues: {
      reason: '',
      otherReason: '',
      status: (currentAction === 'cancel') ? 'cancelled' : 'rejected'
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: cancelInvoiceFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers)
    })
  })
  return (

    <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

      <FormSelectField name={'reason'} labelKey={`Fields.label.reason.${currentAction}`} classes={classes} displayEmpty
                       type={'invoiceCancel'} formActions={formActions} row required
                       hint={<Typography variant={'body1'} className={classes.hint}><FormattedMessage
                         id={`InvoiceActions.${currentAction}.hint`}
                         values={{
                           strong: chunks =>
                             <strong>{chunks}</strong>
                         }}/></Typography>}/>

      {formActions.values.reason === 'otherReason' &&
      <FormTextField name={'otherReason'} labelKey={`Fields.label.reason.${currentAction}`} row required
                     classes={classes} formActions={formActions} lines={2}/>
      }

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                onClick={formActions.handleSubmit}
                disabled={formActions.isSubmitting || !formActions.isValid}
        >
          <FormattedMessage id={`AddNewDialog.InvoiceActions.${currentAction}`}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='invoiceSteps.Cancel'/>
        </Button>
      </div>
      {!!formActions.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default CancelRejectInvoiceForm
